import axios from 'axios';
import { SERVICE_URL } from '@/store/_commons'
import getReCaptchaHeaderTBR from '@/utils/recaptchaTBR'

// ----------------------------
// Payment

const namespaced = true;

const state = () => ({ 
  forteOttResponse: { status: -1 },     // TODO: no longer needed?
});

const mutations = {
  setOttResponse(state, data) {
    console.log('mutating ott res', data)
    state.forteOttResponse = data;
  }
};

const actions = {
  /**
   * Gets related fees (to be charged to customer's CC) for a specific DMV service.
   * @returns {Promise<*>}
   */

  async getFees({ rootState }) {
    const endpoint = `${SERVICE_URL}payment/fees`;

    try {
      const response = await axios.get(endpoint, { params: { visitTypeId: rootState.user.resType } });
      return response;
    } catch (error) {
      return error.response; 
    }
  },

  /**
   * Makes customer's wallet lighter.
   * @param {object} context - The Vuex context (commit, dispatch, etc.)
   * @param {object} data - The payment processing data payload.
   * @returns {Promise<*>}
   */
  async pay(context, data) { // Destructure commit from context if needed
    const endpoint = `${SERVICE_URL}payment/process`;
    const config = await getReCaptchaHeaderTBR('post', endpoint);

    try {
      const response = await axios.post(endpoint, data, config);
      return response;
    } catch (error) {
      // Return the error response status/data or re-throw
      return error.response;
    }
  },

  // TODO: no longer needed?
  setForteResponse({ commit }, data) {
    commit('setOttResponse', data);
  }
};

const getters = {
  paymentStoreData: state => ({
    forteOttResponse: state.forteOttResponse,
  })
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
